import { FC, SetStateAction, Dispatch } from 'react';
import { FiltersButtons, FiltersLayout } from '../../../components';
import { Grid } from '@mui/material';
import { SalesNeighborhoodDropdown } from '../../../components/dropdowns/sales-neighborhood-dropdown';
import { SalesPlansDropdown } from '../../../components/dropdowns/sales-plans-dropdown';
import { SalesTerritoryDropdown } from '../../../components/dropdowns/sales-territory-dropdown';
interface IAvailableSpecHomesFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSelectedTerritoryId?: (val: string | number) => void;
  selectedTerritoryId?: string | number;
  setSelectedNeighborhoodId?: (val: string | number) => void;
  selectedNeighborhoodId?: string | number;
  setSelectedPlanId?: (val: string | number) => void;
  selectedPlanId?: string | number;
}
export const AvailableSpecHomesFilters: FC<IAvailableSpecHomesFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  setSelectedTerritoryId,
  selectedTerritoryId,
  setSelectedNeighborhoodId,
  selectedNeighborhoodId,
  setSelectedPlanId,
  selectedPlanId
}) => {
  return (
    <FiltersLayout>
      {setSelectedTerritoryId && (
        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <SalesTerritoryDropdown
            value={selectedTerritoryId}
            handleChange={value => {
              setSelectedTerritoryId(value as string);
              //Reset all related selected values when a new value is set
              setSelectedNeighborhoodId('');
              setSelectedPlanId('');
            }}
            apiParams={{ IsActive: true, hasSpecs: true }}
            handleClear={() => {
              setSelectedTerritoryId('');
              setSelectedNeighborhoodId('');
              setSelectedPlanId('');
            }}
          />
        </Grid>
      )}
      {setSelectedNeighborhoodId && (
        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <SalesNeighborhoodDropdown
            value={selectedNeighborhoodId}
            handleChange={value => {
              setSelectedNeighborhoodId(value as string);
              //Reset all related selected values when a new value is set
              setSelectedPlanId('');
            }}
            apiParams={{ isActive: true, hasSpecs: true, territoryId: selectedTerritoryId }}
            handleClear={() => {
              setSelectedNeighborhoodId('');
              setSelectedPlanId('');
            }}
          />
        </Grid>
      )}
      {setSelectedPlanId && (
        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <SalesPlansDropdown
            value={selectedPlanId}
            handleChange={value => {
              setSelectedPlanId(value as string);
            }}
            apiParams={{
              showArchived: false,
              hasSpecs: true,
              neighborhoodId: selectedNeighborhoodId
            }}
            handleClear={() => {
              setSelectedPlanId('');
            }}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedTerritoryId && setSelectedTerritoryId('');
            setSelectedNeighborhoodId && setSelectedNeighborhoodId('');
            setSelectedPlanId && setSelectedPlanId('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
